import { UITypes } from "types"

import MessageReportStatusCount from "components/table/columnComponents/MessageReportStatusCount"

export const messageHistoryTableHeaderCells: UITypes.TableHeaderCell[] = [
  {
    title: "Title",
    type: "sort-search",
    name: "title",
  },
  {
    title: "Message",
    type: "sort-search",
    cellComponent: "markdown",
    name: "content",
  },
  {
    title: "Creation date",
    type: "default",
    name: "date",
    cellComponent: "datetime",
  },
  {
    title: "Last delivery date",
    type: "sort-date-range",
    name: "most_recent_delivery_date",
    cellComponent: "datetime",
  },
  {
    title: "Next scheduled date",
    type: "date-range",
    name: "scheduled_delivery_date",
    cellComponent: "datetime",
  },
  {
    title: "Delivered",
    type: "sort",
    size: "small",
    name: "delivered",
    cellComponent: MessageReportStatusCount,
  },
  {
    title: "Pending",
    type: "sort",
    size: "small",
    name: "pending",
    cellComponent: MessageReportStatusCount,
  },
  {
    title: "Failed",
    type: "sort",
    size: "small",
    name: "failed",
    cellComponent: MessageReportStatusCount,
  },
]
